module.exports = __webpack_public_path__ + "img/musicSeason1-en.e95cf760.png";